import { handbookProvidersAPI } from "@/views/handbook/Providers/api";
import { handbookContractorsAPI } from "@/views/handbook/contractors/api";

export const getHandbookProviders = async () => {
  try {
    const res = await handbookProvidersAPI.getList();
    return res?.data;
  } catch (e) {}
};
export const addHandbookProvider = async (body = {}) => {
  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    formData.append(key, value);
  });
  try {
    const res = await handbookProvidersAPI.addProvider(formData);
    return res?.data;
  } catch (e) {
  }
};

export const updateHandbookProvider = async (provider_id, body = {}) => {
  try {
    const res = await handbookProvidersAPI.updateProvider(provider_id, body);
    return res?.data;
  } catch (e) {}
};
export const deleteHandbookProvider = async (provider_id) => {
  try {
    const res = await handbookProvidersAPI.deleteProvider(provider_id);
    return res?.data;
  } catch (e) {}
};
export const getCity = async () => {
  try {
    const res = await handbookContractorsAPI.getCity();
    return res?.data;
  } catch (e) {}
};
export const getProviderType = async () => {
  try {
    const res = await handbookProvidersAPI.getProviderType();
    return res?.data;
  } catch (e) {}
};
export const getProviderCountry = async () => {
  try {
    const res = await handbookProvidersAPI.getProviderCountry();
    return res?.data;
  } catch (e) {}
};
export const getContragentType = async () => {
  try {
    const res = await handbookContractorsAPI.getContragentType();
    return res?.data;
  } catch (e) {}
};
export const sendTo1C = async (provider_id, is_send_to_1c) => {
  try {
    const response = await handbookProvidersAPI.sendTo1C(
      provider_id,
      is_send_to_1c,
    );
    return response?.data;
  } catch (error) {}
};
const yesNo = (v) => (v === true || v === 1 ? "Да" : "Нет")

// viewValue / viewTitle — для режима просмотра строки (CustomTable, openRowView)
export const providersHandbookColumns = [
  { name: "actions", field: "actions", label: "", align: "left" },
  { name: "provider_id", field: "provider_id", label: "ID", align: "left" },
  { name: "provider_name", field: "provider_name", label: "Название", align: "left", viewTitle: true },
  {
    name: "is_not_create_auto_payment",
    field: "is_not_create_auto_payment",
    label: "Запрет автоплатежей",
    align: "center",
    viewValue: (r) => yesNo(r.is_not_create_auto_payment),
  },
  { name: "material_marzha", field: "material_marzha", label: "Маржа", align: "right" },
  { name: "is_nds", field: "is_nds", label: "НДС", align: "center", viewValue: (r) => yesNo(r.is_nds) },
  { name: "director_fio", field: "director_fio", label: "ФИО директора", align: "left" },
  { name: "phone", field: "phone", label: "Телефон", align: "left" },
  { name: "address", field: "address", label: "Адрес", align: "left" },
  { name: "city_name", field: "city_name", label: "Город", align: "left" },
  { name: "provider_type_name", field: "provider_type_name", label: "Тип поставщика", align: "left" },
  { name: "guid", field: "guid", label: "ГУИД", align: "left" },
  { name: "bin", field: "bin", label: "БИН", align: "left" },
  { name: "kbe", field: "kbe", label: "КБе", align: "left" },
  { name: "iik", field: "iik", label: "ИИК", align: "left" },
  { name: "bank_name", field: "bank_name", label: "Банк", align: "left" },
  { name: "contract_text", field: "contract_text", label: "Текст для договора", align: "left" },
  { name: "comment", field: "comment", label: "Комментарий", align: "left" },
  { name: "email", field: "provider_email", label: "Email", align: "left" },
  { name: "is_auto_gpr", field: "is_auto_gpr", label: "Отправка заявок", align: "center", viewValue: (r) => yesNo(r.is_auto_gpr) },
  { name: "is_subscribe", field: "is_subscribe", label: "Рассылка", align: "center", viewValue: (r) => yesNo(r.is_subscribe) },
  { name: "is_send_to_1c_text", field: "is_send_to_1c_text", label: "1С", align: "left" },
];
